import React from 'react';
import classNames from 'classnames';
import { useField, useFormikContext } from 'formik';
import Label from '../lib/Label';
import Error from '../lib/Error';
import Container from '../lib/Container';
import { PlusCircle } from "@phosphor-icons/react";

export default function ImageInput(props) {

    const {
        label,
        name,
        autoComplete,
        placeholder,
        disabled,
        onChange,
        image,
        onBlur,
        accept,
        fieldId,
        columns,
        wFull,
        required
    } = props;

    const {setFieldValue} = useFormikContext();

    const [, meta] = useField({
        name,
        type: 'file',
        id: fieldId || name,
        autoComplete
    });

    function onChangeHandler(event) {
        const value = event.target.files[0];

        if (onChange && typeof onChange === 'function') {
            onChange(value, name)
        }

        return setFieldValue(name, value);
    }

    function onBlurHandler(event) {

        const value = event.target.files[0];

        if (onBlur && typeof onBlur === 'function') {
            onBlur(value, name)
        }

        return setFieldValue(name, value);
    }

    const ContainerClasses = classNames({
        "relative border flex items-center justify-center border-line rounded-lg bg-white cursor-pointer mt-1 hover:bg-extralightprimary hover:border-primary bg-center bg-cover ": true,
        "h-100 w-100": !wFull,
        "w-full aspect-video": wFull,
    })

    const InputClasses = classNames({
        "absolute block top-0 left-0 w-full h-full opacity-0 cursor-pointer": true,
        "border border-line": !meta?.error,
        "has-error": meta?.error
    })

    return (
        <Container columns={columns || 1}>
            {label &&
                <Label
                    label={label}
                    name={name}
                    fieldId={fieldId}
                    focused={true}
                    required={required}
                    relative
                />
            }

            <div
                className={ContainerClasses}
                style={{ backgroundImage: `url(${image})` }}
            >
                <input 
                    name={name}
                    type="file"
                    accept={accept}
                    disabled={disabled}
                    className={InputClasses}
                    placeholder={placeholder}
                    onChange={onChangeHandler}
                    onBlur={onBlurHandler}
                />

                {!image &&
                    <PlusCircle weight="fill" className="h-7 w-7 fill-primary"/>
                }
            </div>

            {meta?.error && (
                <Error error={meta.error}/>
            )}
        </Container>
    )
}
